import { shape, string } from "prop-types";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import classify from "web/classify";

import defaultClasses from "./codeAttributesList.scss";

const CODE_ATTRIBUTE_LIST_SIZE = 2;

const CodeAttributeList = ({ classes, codeDetails, producSuperOptions }) => {
  const productAttributeData = codeDetails?.parent_product_data
    ?.product_attribute_data
    ? codeDetails?.parent_product_data?.product_attribute_data
    : {};

  const productAttributeDataKeys = Object.keys(productAttributeData);
  const productAttributeDataValues = Object.values(productAttributeData);

  const productAttributes = [];

  if (productAttributeData) {
    const producSuperOptionsArray = Object.entries(producSuperOptions);

    productAttributeDataKeys.forEach((element) => {
      producSuperOptionsArray.some((key) => {
        if (key[0] === element) {
          productAttributes.push(key[1]);
          return true;
        }

        return false;
      });
    });
  }

  const evenAttributes = [];
  const oddAttributes = [];

  [productAttributeDataValues, productAttributes].map((item) => {
    return item.map((singleAttribute, index) =>
      index % 2 === 0
        ? evenAttributes.push(singleAttribute)
        : oddAttributes.push(singleAttribute)
    );
  });

  const attributesList = oddAttributes.length
    ? [evenAttributes, oddAttributes]
    : [evenAttributes];

  return isArrayHasItems(attributesList) ? (
    <div className={classes.root}>
      {isArrayHasItems(productAttributeDataKeys) &&
      isArrayHasItems(productAttributeDataValues)
        ? attributesList
            .slice(0, CODE_ATTRIBUTE_LIST_SIZE)
            .map((listItem, index) => {
              return (
                <div
                  key={`${index + attributesList.length}`}
                  className={classes.option}
                >
                  <span className={classes.label}>{`${listItem[0]}: `}</span>
                  <span className={classes.name}>{listItem[1]}</span>
                </div>
              );
            })
        : ""}
    </div>
  ) : null;
};

CodeAttributeList.propTypes = {
  classes: shape({
    root: string,
    item: string,
    name: string,
    value: string,
  }).isRequired,
  codeDetails: shape({}),
  producSuperOptions: shape({}),
};

CodeAttributeList.defaultProps = {
  codeDetails: {},
  producSuperOptions: {},
};

export default classify(defaultClasses)(CodeAttributeList);
